import IConfigurationModel from '@/models/configuration-model';
import Analytics from '@/singletons/analytics'
import ToastService from '@/services/page/toast.service'
import SentrySingleton from '@/singletons/sentry-singleton';

export default class CopyLinkService {
    
    private toastService = new ToastService()

    copyLink(link: string) {
        try {
            console.log(link)
            const el = document.createElement('textarea')
            el.value = link
            document.body.appendChild(el)
            el.select()
            el.setSelectionRange(0, 99999) /* For mobile devices */
            document.execCommand('copy')
            document.body.removeChild(el)
        } catch (err: any) {
            SentrySingleton.instance.captureException(err)
        }

        this.toastService.showSuccess('コピーされました')
        Analytics.instance.sendCopyLinkEvent()
    }
}